import { topics } from "@/mocks/topics";

interface OverviewProps {
  active: string;
  onSelect: (slug: string) => void;
}

export default function Overview({ active, onSelect }: OverviewProps) {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          六个栏目，各有各的看点
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
          点击任意栏目即可筛选下方的爆料列表。想一次看完时，也可以选择「全部」。
        </p>

        <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {topics.map((topic) => {
            const isActive = active === topic.slug;
            return (
              <button
                key={topic.slug}
                type="button"
                onClick={() => onSelect(topic.slug)}
                className={`group flex flex-col overflow-hidden rounded-lg border text-left transition-colors cursor-pointer ${
                  isActive
                    ? "border-primary-400 bg-primary-50"
                    : "border-background-300/60 bg-background-100 hover:border-primary-300"
                }`}
              >
                <div className="w-full h-36 overflow-hidden bg-background-200">
                  <img
                    src={topic.image}
                    alt={`${topic.name}栏目配图`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between gap-3">
                    <h3
                      className={`font-heading text-base font-bold ${
                        isActive ? "text-primary-700" : "text-foreground-950"
                      }`}
                    >
                      {topic.name}
                    </h3>
                    <span
                      className={`rounded-full px-2.5 py-1 text-[11px] ${
                        isActive ? "bg-primary-500 text-background-50" : "bg-secondary-50 text-secondary-800"
                      }`}
                    >
                      {topic.count} 条
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{topic.desc}</p>
                  <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    {isActive ? "当前已选中" : "点击筛选"}
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i
                        className={isActive ? "ri-checkbox-circle-fill text-primary-500" : "ri-arrow-right-line"}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}